import { render, staticRenderFns } from "./ModalEditWarehouses.vue?vue&type=template&id=5da1122b&scoped=true&"
import script from "./ModalEditWarehouses.vue?vue&type=script&lang=js&"
export * from "./ModalEditWarehouses.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditWarehouses.vue?vue&type=style&index=0&id=5da1122b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da1122b",
  null
  
)

export default component.exports